module.exports = __webpack_public_path__ + "img/eyein-partner-mikrotik.6f88ee00.webp";